export const ignoreErrors = [
  // >>> START OF LIST FROM SENTRY DOCS >>>

  // Random plugins/extensions
  "top.GLOBALS",

  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",

  // Facebook borked
  "fb_xd_fragment",

  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",

  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",

  // <<< END OF LIST FROM SENTRY DOCS <<<

  // >>> START OF CHAINPATROL-SPECIFIC IGNORES >>>

  // Ignore Invalid URL errors
  "Invalid URL",

  // Ignore one of the errors for now not to exceed Sentry quota. More details in SUP-283
  "TRPCError: Invalid `prisma.report.findMany()` invocation: Inconsistent query result: Field asset is required to return data, got `null` instead.",

  // Related to SUP-349
  "User is not authenticated",

  // <<< END OF CHAINPATROL-SPECIFIC IGNORES >>>
];

export const denyUrls = [
  // >>> START OF LIST FROM SENTRY DOCS >>>

  // Facebook flakiness
  /graph\.facebook\.com/i,

  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,

  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,

  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,

  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,

  // <<< END OF LIST FROM SENTRY DOCS <<<
];
